/* eslint-disable @typescript-eslint/no-explicit-any */
import { Layout, TextLink } from '@oneaudi/unified-web-components';
import * as Dialog from '@radix-ui/react-dialog';

import styled from 'styled-components';

export const StyledTextLinkButton = styled(TextLink)`
	justify-self: start;
	align-self: flex-start;
`;

export const StyledLabel = styled.span`
	font-size: 12px;
	line-height: 20px;
	text-decoration: underline;
	text-underline-offset: 6px;

	cursor: pointer;
`;

export const StyledTriggerButton = styled(Dialog.Trigger)`
	width: fit-content;
`;

export const StyledDialogContent = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const StyledFullLayout = styled(Layout)`
	width: 100%;
	height: 100%;

	iframe {
		height: 100%;
		width: 100%;
		min-height: 80dvh;
	}
`;
